import { render, staticRenderFns } from "./WorkAnniversary.vue?vue&type=template&id=491164a7&scoped=true"
import script from "./WorkAnniversary.vue?vue&type=script&lang=js"
export * from "./WorkAnniversary.vue?vue&type=script&lang=js"
import style0 from "./WorkAnniversary.vue?vue&type=style&index=0&id=491164a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491164a7",
  null
  
)

export default component.exports